import { SvgIcon } from "@mui/material";

export const ExitIcon = ({ color = "#686868" }: { color: string }) => {
  return (
    <SvgIcon>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          style={{ maskType: "alpha" }}
          id="mask0_8359_48599"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
        >
          <rect width="22" height="22" fill={color} />
        </mask>
        <g mask="url(#mask0_8359_48599)">
          <path
            d="M5.86634 17.4163L4.58301 16.133L9.71634 10.9997L4.58301 5.86634L5.86634 4.58301L10.9997 9.71634L16.133 4.58301L17.4163 5.86634L12.283 10.9997L17.4163 16.133L16.133 17.4163L10.9997 12.283L5.86634 17.4163Z"
            fill={color}
          />
        </g>
      </svg>
    </SvgIcon>
  );
};

export default ExitIcon;
